import blogDataJson from './blogs.json';

// Ensure we always export an array, handling different webpack import formats
let blogData = [];
if (Array.isArray(blogDataJson)) {
  blogData = blogDataJson;
} else if (blogDataJson && Array.isArray(blogDataJson.default)) {
  blogData = blogDataJson.default;
} else if (blogDataJson && typeof blogDataJson === 'object') {
  // Try to extract array from object
  blogData = Object.values(blogDataJson).find(val => Array.isArray(val)) || [];
}

export default blogData;

